import React, { useState } from 'react';
import { Tabs, Typography } from 'antd';
import { useAuth } from '../auth/authcontext';
import BlockedItemsTab from '../components/itemblock/blockeditemstab';
import ItemBlockMenusTab from '../components/itemblock/menustab';
import ItemBlockRecipesTab from '../components/itemblock/recipestab';
import ItemBlockHistoryTab from '../components/itemblock/historytab';

const { Title } = Typography;

const ItemBlockPage: React.FC = () => {
    const { userId } = useAuth();
    const userGuid = userId || '';
    const [activeTab, setActiveTab] = useState('blocked');

    const items = [
        { key: 'blocked', label: 'Blocked Items', children: <BlockedItemsTab userGuid={userGuid} activeTab={activeTab} /> },
        { key: 'menus', label: 'Menus', children: <ItemBlockMenusTab userGuid={userGuid} activeTab={activeTab} /> },
        { key: 'recipes', label: 'Recipes', children: <ItemBlockRecipesTab userGuid={userGuid} activeTab={activeTab} /> },
        { key: 'history', label: 'History', children: <ItemBlockHistoryTab activeTab={activeTab} /> },
    ];

    return (
        <div style={{ padding: 24 }}>
            <Title level={2}>Manage Blocked Items</Title>
            <Tabs activeKey={activeTab} onChange={setActiveTab} items={items} />
        </div>
    );
};

export default ItemBlockPage;